import { z } from 'zod';
import apiClient from '../lib/apiClient';

export interface QrCodeResponse {
  qrData: string;
}

export async function fetchQrCodeForNewChannel(): Promise<string> {
  const response = await apiClient.get<string>('/whatsapp/get-qr') as unknown as string;
  return response;
}


export const OpenChannelBXSchema = z.object({
  id: z.number().optional(),
  isActive: z.boolean(),
  // agrega otros campos si los necesitas
});

export const BitrixChatBotSchema = z.object({
  id: z.number().optional(),
  // agrega otros campos si los necesitas
});

export const ChannelSchema = z.object({
  id: z.number(), 
  nameChannel: z.string().nullable(),
  updatedAt: z.string(),
  userId: z.string(),
  phoneChannel: z.string().nullable(),
  createdAt: z.string().optional(),
  isAuthenticated: z.boolean().optional(),
  isReconnecting: z.boolean().optional(),
  subscriptionStatus: z.enum(['active', 'inactive']).optional(),
  openChannelsBX: z.array(OpenChannelBXSchema).optional(),
  bitrixChatBot: BitrixChatBotSchema.optional().nullable(),
  channelPlans: z.array(z.object({
    id: z.number().optional(),
    userId: z.string().optional(),
    channelId: z.number().optional(),
    planId: z.number().optional(),
    usedDialogs: z.number().optional(),
    dialogLimit: z.number().nullable().optional(),
    resetDate: z.string().nullable().optional(),
    active: z.boolean(),
    startDate: z.string().nullable().optional(),
    endDate: z.string().nullable().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    autoRenewal: z.boolean().optional(),
    paymentId: z.string().nullable().optional(),
    amount: z.number().optional(),
    manualPayment: z.boolean().optional(),
    status: z.enum(['ACTIVE', 'GRACE', 'SUSPENDED']).optional(),
    plan: z.object({
      active: z.boolean(),
      createdAt: z.string(),
      description: z.string(),
      id: z.number(),
      name: z.string(),
      price: z.number(),
    }).optional()
  })).optional(),
  whatsappSession: z.object({
    id: z.number().optional(),
    channelId: z.number().optional(),
    isAuthenticated: z.boolean(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
  }).optional().nullable(),
});

export const ChannelsSchema = z.array(ChannelSchema);

export type Channel = z.infer<typeof ChannelSchema>;

// Implement actual API call for getChannels
export async function getChannels(): Promise<Channel[] | undefined> {
  try {
    const data = await apiClient.get('/whatsapp/channels');
    console.log(data);
    
    const response = ChannelsSchema.safeParse(data)
    console.log(response);
    if(response.success) {
      return response.data
    }
  } catch (error) {
    console.error("Error fetching channels:", error);
    throw error; // Re-throw for react-query to handle
  }
}

export async function getChannelById(channelId: Channel['id']) {
  try {
    const data = await apiClient.get(`/whatsapp/channel/${channelId}`);
    const response = ChannelSchema.safeParse(data)
    
    if(response.success) {
      return response.data
    }
  } catch (error) {
    console.error("Error fetching channels:", error);
    throw error; // Re-throw for react-query to handle
  }
}

export async function updateChannelName({channelId, nameChannel}: {channelId: Channel['id'], nameChannel: Channel['nameChannel']}) {
  try {
    await apiClient.patch(`/whatsapp/channel/${channelId}`, {nameChannel});
    return "Successfully updated channel name";
  } catch (error) {
    console.error("Error fetching channels:", error);
    throw error; // Re-throw for react-query to handle
  }
}

export async function getChannelsByUser(userId: string): Promise<Channel[] | undefined> {
  try {
    const data = await apiClient.get(`/backoffice/channels?userId=${userId}`);
    
    
    const response = ChannelsSchema.safeParse(data)
    console.log({data, response});
    if(response.success) {
      return response.data
    }
  } catch (error) {
    console.error("Error fetching channels:", error);
    throw error; // Re-throw for react-query to handle
  }
}

// Schemas for Usage
export const UsageRecordSchema = z.object({
  id: z.number(),
  userId: z.string(),
  model: z.string(),
  channelId: z.number(),
  inputTokens: z.number(),
  outputTokens: z.number(),
  priceMillionInputToken: z.number().nullable(),
  priceMillionOutputToken: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const UsageResponseSchema = z.object({
  data: z.array(UsageRecordSchema),
  pagination: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    totalPages: z.number(),
  }),
});

export type UsageRecord = z.infer<typeof UsageRecordSchema>;
export type UsageResponse = z.infer<typeof UsageResponseSchema>;

export interface GetUsageParams {
  userId: string;
  channelId: number;
  page?: number;
  limit?: number;
  month?: number;
  year?: number;
}

export async function getUsage(params: GetUsageParams): Promise<UsageResponse | undefined> {
  try {
    console.log(params);
    
    const data = await apiClient.get('/agent/usage', {
      params
    });
    
    const response = UsageResponseSchema.safeParse(data);
    console.log({ data, response });
    
    if (response.success) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching usage:", error);
    throw error;
  }
}

/**
 * Disconnect a WhatsApp channel (logout)
 */
export async function disconnectChannel(channelId: Channel['id']) {
  try {
    return await apiClient.post(`/whatsapp/channel/${channelId}/disconnect`);
  } catch (error) {
    console.error("Error disconnecting channel:", error);
    throw error;
  }
}

/**
 * Delete a channel completely (disconnects if active and removes from DB)
 */
export async function deleteChannel(channelId: Channel['id']) {
  try {
    return await apiClient.delete(`/whatsapp/channel/${channelId}`);
  } catch (error) {
    console.error("Error deleting channel:", error);
    throw error;
  }
}